import { z } from "zod";
import { AccountSchema } from "../../models/account.schema";

export const PrivateAccountControllerResponseSchema = {
  getAccountByEmail: AccountSchema.nullable(),

  createAuthAccount: z.boolean(),

  getMyAccount: AccountSchema.nullable(),

  createMyAccount: AccountSchema.nullable(),

  updateMyAccount: AccountSchema.nullable(),
};
